import Vue from 'vue'
import axios from 'axios'
import router from '@/router/index.js'
import { Toast } from 'vant'
import global_ from '../../static/config/global' // 自定义配置文件
import CryptoJS from 'crypto-js'

export default {
    // 请求封装（json）
    requestData: function (_url, _method, _data) {
        var userToken = localStorage.getItem('userToken') || ''
        return new Promise((resolve, reject) => {
            axios({
                method: _method,
                headers: {
                    'privateUserToken': userToken,
                    'Content-type': 'application/json',
                    'requestHost': this.getRequestHost(),
                    'affiliate': this.getAffiliate(),
                    'adlk': this.getAdlk()
                },
                url: _url,
                data: _data
            }).then((response) => {
                resolve(response)
            }).catch((error) => {
                // 登录失效
                if (error.response.data.body.message == 60001) {
                    router.push({ path: '/home' })
                    setTimeout(() => {
                        window.location.reload()
                    }, 100)
                } else {
                    Toast({ message: error.response.data.body.message, duration: 1000 })
                }
                reject(error)
            })
        })
    },

    // 请求封装（params）
    requestDataParams: function (_url, _method, _data) {
        var userToken = localStorage.getItem('userToken') || ''
        return new Promise((resolve, reject) => {
            axios({
                method: _method,
                headers: {
                    'privateUserToken': userToken,
                    'Content-type': 'application/json',
                    'requestHost': this.getRequestHost(),
                    'affiliate': this.getAffiliate(),
                    'adlk': this.getAdlk()
                },
                url: _url,
                params: _data
            }).then((response) => {
                resolve(response)
            }).catch((error) => {
                // 登录失效
                if (error.response.data.body.message == 60001) {
                    router.push({ path: '/home' })
                    setTimeout(() => {
                        window.location.reload()
                    }, 100)
                } else {
                    Toast({ message: error.response.data.body.message, duration: 1000 })
                }
                reject(error)
            })
        })
    },

    // 请求封装（form-data）
    requestDataFile: function (_url, _method, _data) {
        var userToken = localStorage.getItem('userToken') || ''
        let formData = new FormData() // 创建一个form对象
        for (let i in _data) {
            if (_data[i] instanceof Array) {
                // 数组
                for (const j in _data[i]) {
                    formData.append(i, _data[i][j])
                }
            } else {
                formData.append(i, _data[i])
            }
        }
        return new Promise((resolve, reject) => {
            axios({
                method: _method,
                headers: {
                    'privateUserToken': userToken,
                    'Content-type': 'multipart/form-data',
                    'requestHost': this.getRequestHost(),
                    'affiliate': this.getAffiliate(),
                    'adlk': this.getAdlk()
                },
                url: _url,
                data: formData
            }).then((response) => {
                resolve(response)
            }).catch((error) => {
                // 登录失效
                if (error.response.data.body.message == 60001) {
                    router.push({ path: '/home' })
                    setTimeout(() => {
                        window.location.reload()
                    }, 100)
                } else {
                    Toast({ message: error.response.data.body.message, duration: 1000 })
                }
                reject(error)
            })
        })
    },

    // SHA256加密
    SHA256Encrypt: function (string) {
        return CryptoJS.SHA256(string).toString()
    },

    // AEC加密
    AECEncrypt: function (string) {
        return CryptoJS.AES.encrypt(string, 'YIGOU').toString()
    },

    // AEC解密
    AECDecrypt: function (string) {
        return CryptoJS.AES.decrypt(string, 'YIGOU').toString(CryptoJS.enc.Utf8)
    },

    // 获取超商地址
    getSupermarketArea: function () {
        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = 'https://dadu-1377017581.cos.ap-hongkong.myqcloud.com/address/supermarket_list.min.js' // 线上
        document.body.appendChild(script)
        script.onload = function () {
            Vue.prototype.supermarketList = supermarket_list
        }
    },

    // 获取日本地址
    getJapanArea: function () {
        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = 'https://yigoutemai.oss-cn-hongkong.aliyuncs.com/japan.min.js' // 香港cdn
        document.body.appendChild(script)
        script.onload = function () {
            Vue.prototype.areaList.area_list.push(japan)
        }
    },

    // 事件监听
    monitor: function (obj) {
        var affiliate = sessionStorage.getItem('affiliate')
        obj.source = this.isApp() ? 'APP' : affiliate ? affiliate : 'WEB'
        const param = this.urlEncode(obj) // json拼接url参数

        const monitor = document.createElement('img')
        monitor.src = `${global_.BASE_URL}/api/monitor/mt${param}`
        document.body.appendChild(monitor)
        document.body.removeChild(monitor)
    },

    // 获取投放来源
    getAffiliate: function () {
        var affiliate = sessionStorage.getItem('affiliate') || ''
        return this.isApp() ? 'APP' : affiliate ? affiliate : 'WEB'
    },

    // 获取投放平台
    getAdlk: function () {
        var adlk = sessionStorage.getItem('adlk') || ''
        return adlk
    },

    // 微信输入框不回弹处理（1）
    inBlur: function () {
        let ua = navigator.userAgent.toLowerCase()
        let u = navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

        if (ua.match(/MicroMessenger/i) == 'micromessenger' && !!u) {
            this.temporaryRepair()
        }
    },

    // 微信输入框不回弹处理（2）
    temporaryRepair: function () {
        var currentPosition, timer
        var speed = 1 // 页面滚动距离
        timer = setInterval(function () {
            currentPosition = document.documentElement.scrollTop || document.body.scrollTop
            currentPosition -= speed
            window.scrollTo(0, 0) // 页面向上滚动
            clearInterval(timer)
        }, 1)
    },

    // url方式获取参数
    getUrlKey: function (name) {
        var value = decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(window.location.href) || [, ''])[1].replace(/\+/g, '%20')) || ''
        return value
    },

    // 判断当前是在网页中还是app中
    isApp: function () {
        var hostname = window.location.hostname
        var value
        if (hostname == '') {
            value = true
        } else {
            value = false
        }
        return value
    },

    // 请求头中的站点标识（后端不识别 localhost，本地访问统一按 127.0.0.1:8080 处理）
    getRequestHost: function () {
        if (this.isApp()) {
            return 'www.dadu.tw'
        }
        if (window.location.hostname == 'localhost') {
            return '127.0.0.1:8080'
        }
        return window.location.host
    },

    // 判断当前设备是iOS还是Android
    isIosOrAndroid: function () {
        var value
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
            value = 'iOS'
        } else if (/(Android)/i.test(navigator.userAgent)) {
            value = 'Android'
        } else {
            value = ''
        }
        return value
    },

    // 货币配置（暂时没有用到）
    currency: function () {
        return 'NT$'
    },

    // 信用卡配置
    stripeOptions: function () {
        return {
            stripe: 'pk_test_51Miy1CHdHcNcsOSiqfAN67nAAXLK2H5itzsawe4mQXrszptyx0S0hkyWq3GDpOEl0ZmizPDGe1ZVvg5Po1re6bFR00vgURwUH7', // 密匙
            card: {
                style: {
                    base: {
                        color: '#32325d',
                        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                        fontSmoothing: 'antialiased',
                        fontSize: '17px',
                        '::placeholder': { color: '#aab7c4' }
                    },
                    invalid: {
                        color: '#fa755a',
                        iconColor: '#fa755a'
                    }
                }
            }
        }
    },

    // 分享配置
    shareOptions: function () {
        return [
            [
                { name: 'Facebook', icon: require('@/assets/img/icon_facebook.png') },
                { name: 'Line', icon: require('@/assets/img/icon_line.png') },
                { name: 'Messenger', icon: require('@/assets/img/icon_messenger.png') },
                { name: '讯息', icon: require('@/assets/img/icon_message.png') }
            ], [
                { name: '邮件', icon: require('@/assets/img/icon_mail.png') },
                { name: '复制链接', icon: require('@/assets/img/icon_copy.png') }
            ]
        ]
    },

    // 选择分享
    shareSelect: function (obj, other) {
        if (obj.name == 'Facebook') {
            window.open(`https://www.facebook.com/sharer.php?u=${encodeURIComponent(window.location.href)}`)
        }
        if (obj.name == 'Line') {
            window.open(`line://msg/text/${encodeURIComponent(window.location.href)}`)
            // window.open(`https://lineit.line.me/share/ui?url=${encodeURIComponent(window.location.href)}`)
        }
        if (obj.name == 'Messenger') {
            window.open(`fb-messenger://share?link=${encodeURIComponent(window.location.href)}`)
        }
        if (obj.name == '讯息') {
            if (Object.prototype.toString.call(other) == '[object Object]') {
                window.location.href = `sms:? &body=【大渡陶瓷】${other.title} ${window.location.href}`
            } else {
                window.location.href = `sms:? &body=【大渡陶瓷】${window.location.href}`
            }
        }
        if (obj.name == '邮件') {
            var html = ''
            if (Object.prototype.toString.call(other) == '[object Object]') {
                html = `<a style="color: #000;text-decoration: none;" href="${window.location.href}">
                            <div style="display: flex;">
                                <div><img style="width: 95px;height: 95px;" src="${other.img}" /></div>
                                <div style="position: relative;flex: 1;font-size: 15px;padding-left: 10px;">
                                    <div>${other.title}</div>
                                    <div style="position: absolute;bottom: 0;color: #ff0f23;">NT$${other.price}</div>
                                </div>
                            </div>
                        </a>`
                window.location.href = `mailto:?subject=大渡陶瓷：${other.title}&body=${html}</a>`
            } else {
                html = `<a style="color: #000;text-decoration: none;" href="https://www.dadu.tw">
                            <div>
                                <img style="width: 100%;" src="https://dadu-1377017581.cos.ap-hongkong.myqcloud.com/images/2025/09/16/12f752c9-7456-4af3-81ae-b1fe6b05ba62.jpeg" />
                                <div style="padding: 10px 0;">大渡陶瓷——器載大渡，茶納乾坤。在東方茶道的靜謐深處，器物從來不只是容器，而是德性在泥土中的重生。大渡陶瓷以「器以載道」為魂，承襲唐宋御窯精魄，融匯當代國際美學，為全球茶道愛好者築造一方跨越時空的器物道場。滿NT$800免運 / 支持貨到付款 / 官方自營 / 100%正品保障 / 7天無憂退換貨。</div>
                            </div>
                        </a>`
                window.location.href = `mailto:?subject=大渡陶瓷——器載大渡，茶納乾坤&body=${html}</a>`
            }
        }
        if (obj.name == '复制链接') {
            const url = window.location.href
            const copyInput = document.createElement('input')
            copyInput.value = url
            document.body.appendChild(copyInput)
            copyInput.select()
            document.execCommand('Copy')
            Toast({ message: '復製成功', duration: 1000 })
            document.body.removeChild(copyInput)
        }
    },

    // 下载app
    app: function () {
        if (this.isIosOrAndroid() == 'iOS') {
            window.open(`itms-appss://apps.apple.com/tw/app/%E5%A4%A7%E5%BE%B7%E9%99%B6%E7%93%B7/id6744322851`)
        } else if (this.isIosOrAndroid() == 'Android') {
            // window.open(`https://play.google.com/store/apps/details?id=com.dadu.app`)
            Toast({ message: '即將上線，感謝您的關注！', duration: 1000 })
        } else {
            Toast({ message: '請使用手機瀏覽器進行下載', duration: 1000 })
        }
    },

    // 获取当前app版本
    getCurrentAppVersion: function () {
        return plus.runtime.version
    },

    // messenger
    messenger: function () {
        if (this.isApp()) {
            plus.runtime.openURL('https://m.me/1108847598986103')
        } else {
            window.open('https://m.me/1108847598986103')
        }
    },

    // fb公共主页
    fb: function () {
        if (this.isApp()) {
            if (this.isIosOrAndroid() == 'iOS') {
                plus.runtime.openURL('https://www.facebook.com/profile.php?id=61590895292615')
            } else if (this.isIosOrAndroid() == 'Android') {
                plus.runtime.openWeb('https://www.facebook.com/profile.php?id=61590895292615')
            }
        } else {
            window.open('https://www.facebook.com/profile.php?id=61590895292615')
        }
    },

    // Line
    line: function () {
        if (this.isApp()) {
            if (this.isIosOrAndroid() == 'iOS') {
                plus.runtime.openURL('https://line.me/R/ti/p/@719dcdtj')
            } else if (this.isIosOrAndroid() == 'Android') {
                plus.runtime.openWeb('https://line.me/R/ti/p/@719dcdtj')
            }
        } else {
            window.open('https://line.me/R/ti/p/@719dcdtj')
        }
    },

    // TikTok
    tt: function () {
        if (this.isApp()) {
            if (this.isIosOrAndroid() == 'iOS') {
                plus.runtime.openURL('https://www.tiktok.com/@www.dadu.tw')
            } else if (this.isIosOrAndroid() == 'Android') {
                plus.runtime.openWeb('https://www.tiktok.com/@www.dadu.tw')
            }
        } else {
            window.open('https://www.tiktok.com/@www.dadu.tw')
        }
    },

    // 电话
    tel: function () {
        window.location.href = 'tel:+886910265361'
    },

    // 邮箱
    email: function () {
        window.location.href = 'mailto:dadu@dadu.tw'
    },

    // 去首页
    goHome: function () {
        router.push({ path: '/home' })
    },

    // 返回上一页
    returnBack: function (page) {
        router.go(page)
    },

    // 添加足迹
    addFoot: function (obj) {
        var footList = localStorage.getItem('footList') || []
        footList = eval(footList)
        if (footList.length) {
            // 判断足迹是否有相同的商品
            if (this.isFoot(obj, footList)) {
                // 获取下标
                var index = footList.findIndex((data) => {
                    return data.id == obj.id
                })
                footList.splice(index, 1)
                footList.unshift(obj)
            } else {
                if (footList.length >= 500) {
                    footList.splice(499, 1)
                    footList.unshift(obj)
                } else {
                    footList.unshift(obj)
                }
            }
        } else {
            footList.unshift(obj)
        }
        localStorage.setItem('footList', JSON.stringify(footList))
    },

    // 判断足迹是否有相同的商品
    isFoot: function (obj, list) {
        for (const i in list) {
            if (obj.id == list[i].id) {
                return true
            }
        }
        return false
    },

    // 特殊字符串转换为数组
    speciaStringToArray: function (string) {
        var data = []
        string.split(' &,& ').map(function (e) {
            var _data = {}
            e.replace('{', '').replace('}', '').split(',').map(function (_e) {
                var d = _e.split(':')
                var s = ''
                if (d[1] == 'http' || d[1] == 'https') {
                    s += d[1] + ':' + d[2]
                } else {
                    s += d[1]
                }
                _data[d[0]] = s
            })
            data.push(_data)
        })
        return data
    },

    // json拼接url参数
    urlEncode: function (obj) {
        var param = '?'
        for (const i in obj) {
            param += `${i}=${obj[i]}&`
        }
        param = param.substring(0, param.length - 1)
        return param
    },

    // 模拟数据
    // 地址列表
    addressList: function () {
        return [{
            name: '杜克',
            phone: '182****4031',
            address: '软件新城软件研发基地二期南西安软件新城软件研发基地2期A3-1',
            default: true,
            label: '0',
            labelTitle: '家'
        }, {
            name: '杜发明',
            phone: '182****4031',
            address: '软件新城软件研发基地二期南西安软件新城软件研发基地2期A3-2',
            default: false,
            label: '1',
            labelTitle: '公司'
        }, {
            name: '杜发明',
            phone: '182****4031',
            address: '软件新城软件研发基地二期南西安软件新城软件研发基地2期A3-3',
            default: false,
            label: '2',
            labelTitle: '学校'
        }, {
            name: '杜发明',
            phone: '182****4031',
            address: '软件新城软件研发基地二期南西安软件新城软件研发基地2期A3-4',
            default: false,
            label: '',
            labelTitle: ''
        }, {
            name: '杜发明',
            phone: '182****4031',
            address: '软件新城软件研发基地二期南西安软件新城软件研发基地2期A3-5',
            default: false,
            label: '',
            labelTitle: ''
        }, {
            name: '杜发明',
            phone: '182****4031',
            address: '软件新城软件研发基地二期南西安软件新城软件研发基地2期A3-6',
            default: false,
            label: '',
            labelTitle: ''
        }, {
            name: '杜发明',
            phone: '182****4031',
            address: '软件新城软件研发基地二期南西安软件新城软件研发基地2期A3-7',
            default: false,
            label: '',
            labelTitle: ''
        }, {
            name: '杜发明',
            phone: '182****4031',
            address: '软件新城软件研发基地二期南西安软件新城软件研发基地2期A3-8',
            default: false,
            label: '',
            labelTitle: ''
        }, {
            name: '杜发明',
            phone: '182****4031',
            address: '软件新城软件研发基地二期南西安软件新城软件研发基地2期A3-9',
            default: false,
            label: '',
            labelTitle: ''
        }]
    }
}



// WEBPACK FOOTER //
// ./src/util/common.js